<template>
  <div>
    <filter-bar
      v-model="filters"
      :fields="filterFields"
      :search-scopes="aSearchType"
      search-placeholder="Búsqueda general..."
    >
      <template v-slot:actions>
        <v-btn
          color="primary"
          style="
            color: black;
            box-shadow: 0px 20px 40px #00000029;
            border-radius: 8px;
            font-family: 'Poppins', sans-serif !important;
            font-weight: 600;
            height: 40px;
          "
          @click="setCreateOrder"
          >Nueva orden
        </v-btn>
      </template>
    </filter-bar>
    <NewPurchaseOrder
      @close="openDialogOrder = false"
      :openDialogOrder="openDialogOrder"
    ></NewPurchaseOrder>
  </div>
</template>

<script>
import NewPurchaseOrder from "@/components/views/Requests/NewOrder";
import { getInProgressProjects } from "@/utils/inProgressProjects";

export default {
  props: {
    // import texts from admin
    texts: Object,
    mdUp: Boolean,
    smUp: Boolean,
  },
  data() {
    return {
      openDialogOrder: false,
      areaChosen: null,
      statusChosen: null,
      sSearch: "",
      bMenuFinal: false,
      bMenuInitial: false,
      dateStart: null,
      dateEnd: null,

      // Projects are filtered with the project picker, so "Buscar en"
      // doesn't offer them.
      sSearchType: "2",
      aSearchType: [
        { value: "2", text: "Proveedor" },
        { value: "3", text: "Método de pago" },
        { value: "4", text: "Material" },
      ],
      statusOptions: [],
      projectOptions: [],
      aProject: [],

      bMenu: false,
      aDates: [],
      sMaxDate: "",
      tStart: "",
      tEnd: "",

      sDates: "",
      dates: [],
      sMaxDate: new Date().toISOString().slice(0, 10),
      menu: false,
      bAddDates: false,
    };
  },
  components: {
    NewPurchaseOrder,
    FilterBar: () => import("@/components/core/FilterBar"),
  },
  mounted() {
    db.get(`${uri}/api/v1/purchase_order_status`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("user-tk") },
    })
      .then((resp) => {
        this.statusOptions = resp.data.orderStatus.filter((e) => e.sName !== "Pagada");
      })
      .catch(() => {});
    getInProgressProjects()
      .then((projects) => {
        this.projectOptions = projects;
      })
      .catch(() => {});
  },
  computed: {
    filterFields() {
      return [
        { key: "projects", type: "select", label: "Proyectos", items: this.projectOptions, itemText: "sName", itemValue: "sProjectId", multiple: true, before: true },
        { key: "status", type: "select", label: "Estatus", items: this.statusOptions, itemText: "sName", itemValue: "sPurchaseOrderStatusId" },
        { key: "dates", type: "dates", label: "Fechas" },
      ];
    },
    // Shared filter bar <-> this component's existing filter fields.
    filters: {
      get() {
        return {
          projects: this.aProject,
          search: this.sSearch || "",
          searchScope: this.sSearchType,
          status: this.statusChosen,
          dates: this.tStart ? [this.tStart, this.tEnd] : [],
        };
      },
      set(v) {
        if (JSON.stringify(v.projects) !== JSON.stringify(this.aProject)) {
          this.aProject = v.projects;
          this.$store.commit("setProject", this.aProject);
        }
        this.sSearch = v.search;
        if (v.searchScope !== this.sSearchType) this.sSearchType = v.searchScope;
        this.statusChosen = v.status;
        const [start, end] = v.dates || [];
        if (start !== this.tStart || end !== this.tEnd) {
          this.tStart = start || null;
          this.tEnd = end || start || null;
          // Local (Mexico) day boundaries as UTC timestamps, since orders are
          // stored in UTC; the end date includes the whole day.
          const toUtc = (d, h, m, sec, ms) => {
            if (!d) return null;
            const [y, mo, day] = d.split("-").map(Number);
            return new Date(y, mo - 1, day, h, m, sec, ms).toISOString();
          };
          this.$emit("getDateRange", {
            tStart: toUtc(this.tStart, 0, 0, 0, 0),
            tEnd: toUtc(this.tEnd, 23, 59, 59, 999),
          });
        }
      },
    },
  },
  beforeMount() {
    this.$store.commit("setSearch", "");
    this.$store.commit("setStatus", null);
    this.$store.commit("setStartDate", null);
    this.$store.commit("setEndDate", null);
    this.$store.commit("setProject", []);
    //  this.$store.commit("setDebtDays", null);
  },
  methods: {
    openDialogNewPurchaseOrder() {
      this.openDialogOrder = true;
    },
    setCreateOrder() {
      this.$router.push({
        name: "OrdersAddOrDetail",
        params: { sOCId: "Add" },
      });
    },
    save(aDates) {
      this.$refs.menu.save(aDates);
      if (this.aDates.length > 1) {
        let fecha_inicial = this.aDates[0];
        let fecha_final = this.aDates[1];
        if (Date.parse(fecha_inicial) > Date.parse(fecha_final)) {
          let lastDate = this.aDates[1];
          this.aDates = [];
          this.aDates[0] = lastDate;
        } else {
          this.tStart = fecha_inicial;
          this.tEnd = fecha_final;
          this.sDates = this.tStart + " - " + this.tEnd;
          this.$emit("getDateRange", {
            tStart: this.tStart,
            tEnd: this.tEnd,
          });
        }
      }
    },
    getNameProyectSelected(sId) {
      if (sId) {
        var oSearchType = this.aSearchType.filter((val) => val.sId === sId)[0];
        return oSearchType.sName.toLowerCase();
      } else {
        return "";
      }
    },
  },
  watch: {
    aDates() {
      if (this.aDates !== null) {
        if (this.aDates.length > 1) {
          this.bAddDates = true;
          if (this.aDates[0] > this.aDates[1]) {
            let fecha_inicial = this.aDates[1];
            this.aDates = [];
            this.aDates.push(fecha_inicial);
          }
        } else {
          this.bAddDates = false;
        }
      } else {
        this.bAddDates = false;
        this.tStart = null;
        this.tEnd = null;
        this.$emit("getDateRange", {
          tStart: this.tStart,
          tEnd: this.tEnd,
        });
      }
    },
    sDates() {
      if (this.sDates == null) {
        this.aDates = [];
        this.$refs.menu.save([]);
        this.bAddDates = false;
        this.tStart = null;
        this.tEnd = null;
        this.$emit("getDateRange", {
          tStart: this.tStart,
          tEnd: this.tEnd,
        });
      }
    },
    statusChosen: function() {
      this.$store.commit("setStatus", this.statusChosen);
    },
    areaChosen: function() {
      this.$store.commit("setArea", this.areaChosen);
    },
    dateStart: function() {
      this.dateEnd = null;
      this.$store.commit("setStartDate", this.dateStart);
    },
    dateEnd: function() {
      this.$store.commit("setEndDate", this.dateEnd);
    },
    sSearchType() {
      this.$emit("setSearchType", this.sSearchType);
    },
    // set state to local search
    sSearch() {
      this.$store.commit("setSearch", this.sSearch);
    }
    // sSearch: lodash.debounce(function(val) {
    //   this.$store.commit("setSearch", this.sSearch);
    // }, 800),
  },
};
</script>
<style>
.charge-input .v-input__prepend-outer {
  display: none;
}
.v-select__slot,
.v-text-field .v-label {
  font-family: "Poppins", sans-serif;
}
.v-input__slot fieldset {
  background-color: #fafafa;
  border: 1px solid #f2f2f2 !important;
  border-radius: 10px;
}

.mdi-magnify,
.mdi-calendar {
  font-size: 19px !important;
  color: #242424 !important;
}

.FieldLabel {
  text-align: left;
  font: normal normal normal 12px/14px "Poppins", sans-serif;
  margin-bottom: 0px !important;
  margin-left: 20px;
  z-index: 100;
  color: #008b83;
  opacity: 1;
}
.custom-placeholder input::placeholder {
  text-align: left;
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: #000000;
}
.custom-placeholder input::-moz-placeholder {
  text-align: left;
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: #000000;
}
</style>
<style scoped>
.content-search-purchase-orders-global-all {
  display: flex;
  width: 100%;
}
.select-search-type-global {
  width: 200px;
}
.content-search-all {
  display: flex;
  margin-right: 20px;
}

.texts-inputs {
  margin-bottom: -10px;
}

.searchTextField {
  margin-top: -28px;
}
.SearchWrapper {
  max-height: 80px;
  padding-left: 10px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: transparent 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 40px transparent !important;
  border-radius: 30px !important;
  width: 100%;
}

.button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  background: #ffffff;
  cursor: pointer;
  color: #737373;
  padding: 5px 25px;
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 15px;
  border: 2px solid #737373;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
}

#fileToUpload {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
